import { history } from '@umijs/max';
import { signOut } from 'firebase/auth';
import { stringify } from 'querystring';
import { auth } from './firebase';

export const loginOut = async () => {
  await signOut(auth);
  const { search, pathname } = window.location;
  const urlParams = new URL(window.location.href).searchParams;
  /** 此方法会跳转到 redirect 参数所在的位置 */
  const redirect = urlParams.get('redirect');
  // Note: There may be security issues, please note
  if (window.location.pathname !== '/user/login' && !redirect) {
    history.replace({
      pathname: '/user/login',
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};
